import { Box, Tooltip } from "@mui/material";

type TabItem = {
  id: number;
  icon: {
    active: string;
    inactive: string;
  };
  alt: string;
};

type ClaimTabsProps = {
  tabs: TabItem[];
  activeTab: number;
  onTabChange: (id: number) => void;
};

const ClaimTabs = ({ tabs, activeTab, onTabChange }: ClaimTabsProps) => {
  return (
    <Box
      display="flex"
      flexWrap="wrap" 
      justifyContent={{ xs: "center", sm: "flex-start" }} 
      gap={{ xs: 2, sm: 4, md: 8, lg:14 }}
      mb={3}
      bgcolor="#F7F7F7"
      py={{ xs: 1, sm: 1.5 }}
      px={{ xs: 1, sm: 2, md: 3 }}
      borderRadius={50}
    >
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        const tabContent = (
          <Box
            onClick={() => onTabChange(tab.id)}
            sx={{
              background: isActive ? "#EC6E00" : "#FFFFFF",
             p: { xs: 1, sm: 1.5 },
              borderRadius: "20%",
              width: { xs: 50, sm: 60, md: 72 }, 
              height: { xs: 40, sm: 46, md: 52 }, 
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
               transition: "all 0.3s ease",
              "&:hover": {
                background: isActive ? "#EC6E00" : "#f0f0f0",
              },
          
            }}
          >
            <img
              src={isActive ? tab.icon.active : tab.icon.inactive}
              alt={tab.alt}
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
            />
          </Box>
        );

        return isActive ? (
          <Box key={tab.id}>{tabContent}</Box>
        ) : (
          <Tooltip key={tab.id} title={tab.alt} arrow>
            {tabContent}
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default ClaimTabs;
